import React from 'react'
import Logo from './logo'
import { Link } from 'gatsby'
import { Navbar, NavbarBrand, NavbarItem, NavbarMenu, NavbarEnd, Container, NavbarBurger } from 'bloomerjs';

class Header extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
        open: false
    }
}

  render() {
    const { locale, menu } = this.props;
    return (<Navbar>
    <Container style={{maxWidth: '960px'}}>
      <NavbarBrand>
          <NavbarItem>
            <Logo></Logo>
          </NavbarItem>
          <NavbarBurger
            onClick={() =>
              {
                this.setState({
                  open: !this.state.open,
                });
              }
            }
          />
      </NavbarBrand>
      <NavbarMenu isActive={this.state.open}>
        <NavbarEnd>
          <NavbarItem>{ locale !== 'en' ? <Link to="/">English</Link> : <Link to="/vi">Tiếng Việt</Link>}</NavbarItem>
          <NavbarItem><Link to="/blog">Blog</Link></NavbarItem>
          <NavbarItem><Link to={locale !== 'en' ? "/vi/about" : '/about' }>{menu.about}</Link></NavbarItem>
          <NavbarItem><Link to={locale !== 'en' ? "/vi/faq" : '/faq' }>FAQ</Link></NavbarItem>
          <NavbarItem><Link to={locale !== 'en' ? "/vi/soulmate" : '/soulmate' }>Soulmate</Link></NavbarItem>
          <NavbarItem><Link to="/support">{menu.support}</Link></NavbarItem>
        </NavbarEnd>
      </NavbarMenu>
    </Container>
  </Navbar>);
  }
}

export default Header
